import React from "react"

const menu = [
    {
        title: 'option 1',
        link: '',
        icon: ''
    },
    {
        title: 'option 2',
        link: '',
        icon: ''
    },
    {
        title: 'option 3',
        link: '',
        icon: ''
    },
    {
        title: 'option 4',
        link: '',
        icon: ''
    },
    {
        title: 'option 5',
        link: '',
        icon: ''
    }
]

export default menu;